import { render, staticRenderFns } from "./DeleteClassConfirm.vue?vue&type=template&id=857cedf4"
import script from "./DeleteClassConfirm.vue?vue&type=script&lang=js"
export * from "./DeleteClassConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports